<template>
    <NuxtLayout>
        <div class="container">
            <div class="upakovka">
                <Breadcrumb page="Упаковка"/>
                <div class="upakovka-text">
                    <h1 class="title">Упаковка</h1>
                    <p class="subtitle">Опираясь на богатейший профессиональный опыт и достижения современной инженерной мысли, «ПЭК» разработал собственную коллекцию защитной упаковки для всех видов грузов.</p>
                </div>
                <Card v-for="packaging in packagings" :card="packaging" :key="packaging.title"/>
            </div>
        </div>
    </NuxtLayout>
</template>
<script setup>
import Breadcrumb from '~/components/Input/Breadcrumb.vue';
import Card from '~/components/upakovka/Card.vue';
import { usePackagingsData } from '~/composables/usePackagingsData';

useHead({
    title: 'Упаковка груза при перевозке Беларусь – Россия | ПЭК',
    meta: [
        { name: 'description', content: 'Правила и требования к упаковке грузов при грузоперевозке по маршруту Беларусь – Россия транспортной компанией ПЭК.' }
    ]
})

const { packagings } = usePackagingsData();
</script>

<style scoped>
.container {
    margin-top: 40px;
    width: 100%;
    max-width: 1280px;
    margin: 0 auto;
    padding: 0;

    @media screen and (max-width: 1300px) {
        max-width: unset;
        margin: 0;
        padding: 0 16px;
    }
}

.upakovka {
    margin-top: 40px;
    display: flex;
    flex-direction: column;
    gap: 40px;
    margin-bottom: 80px;
}

.upakovka-text {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.title {
    font-weight: 600;
    font-style: SemiBold;
    font-size: 48px;
    leading-trim: NONE;
    line-height: 60px;
    letter-spacing: 0%;
    margin: 0;
}

.subtitle {
    font-weight: 400;
    font-style: Regular;
    font-size: 18px;
    leading-trim: NONE;
    line-height: 26px;
    letter-spacing: 0%;
    margin: 0;
}

</style>